import React, { useEffect, useRef, useState, useContext } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Store } from '../../Utils/Store';

function Header() {
  const location = useLocation();
  const { state } = useContext(Store);
  const toggleButtonRef = useRef(null);
  const menuRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [categories, setCategories] = useState(state.Categories || []);
  const [subcategories, setSubcategories] = useState(state.Subcategories || []);
  
  // Function to close menu
  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  // Handle submenu toggle for mobile
  const handleSubmenuToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Toggle submenu on mobile
    if (window.innerWidth <= 991) {
      const submenu = e.currentTarget.parentElement;
      submenu.classList.toggle('open');
    }
  };
  
  // Close menu when route changes
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);
  
  // Cleanup: Remove body class when component unmounts
  useEffect(() => {
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, []);
  
  // Sync with Store
  useEffect(() => {
    setCategories(state.Categories || [])
    setSubcategories(state.Subcategories || [])
  }, [state.Categories, state.Subcategories])

  useEffect(() => {
    // Initialize dropdown hover functionality exactly like template's include.js
    const initDropdowns = () => {
      if (typeof window.jQuery === 'undefined' && typeof window.$ === 'undefined') {
        setTimeout(initDropdowns, 100);
        return;
      }

      const $ = window.jQuery || window.$;

      // MAIN NAVIGATION - dropdown hover (exact template code)
      // Remove any existing handlers first to prevent duplicates
      $('.nav .dropdown').off('mouseenter mouseleave hover');

      $('.nav .dropdown').hover(
        function () {
          // Mouse enter - show dropdown
          $(this).find('ul:first').stop(true, true).css({
            visibility: "visible",
            display: "none"
          }).fadeIn(300);
        },
        function () {
          // Mouse leave - hide dropdown
          $(this).find('ul:first').stop(true, true).fadeOut(200, function () {
            $(this).css({
              display: "none"
            });
          });
        }
      );

      // Also handle submenu dropdowns
      $('.dropdown-submenu').hover(
        function () {
          $(this).find('ul:first').stop(true, true).css({
            visibility: "visible",
            display: "none"
          }).fadeIn(300);
        },
        function () {
          $(this).find('ul:first').stop(true, true).fadeOut(200, function () {
            $(this).css({
              display: "none"
            });
          });
        }
      );

      // No toggle initialization needed - using React onClick directly

      // Search functionality removed
    };

    initDropdowns();
  }, [categories, subcategories]);

  return (
    <>
      <div className="header-wrapper header-transparent" style={{ top: 0 }}>
        {/* .header.header-style01 start */}
        <header id="header" className="header-style01">
          {/* .container start */}
          <div className="container">
            {/* .main-nav start */}
            <div className="main-nav" style={{ marginTop: 35 }}>
              {/* .row start */}
              <div className="row">
                <div className="col-md-12">
                  <nav className="navbar navbar-default nav-left" role="navigation">
                    {/* .navbar-header start */}
                    <div className="navbar-header">
                      <button 
                        ref={toggleButtonRef}
                        type="button" 
                        className={`navbar-toggle ${isMenuOpen ? '' : 'collapsed'}`}
                        aria-expanded={isMenuOpen}
                        aria-controls="navbar-collapse"
                        style={{ float: 'right', marginTop: '20px', marginRight: '15px' }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const newState = !isMenuOpen;
                          setIsMenuOpen(newState);
                          
                          // Prevent body scroll when menu is open
                          if (newState) {
                            document.body.classList.add('menu-open');
                          } else {
                            document.body.classList.remove('menu-open');
                          }
                        }}
                      >
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                      </button>
                      <div className="logo">
                        <Link to="/" style={{ display: 'block', maxWidth: '200px' }}>
                          <img
                            src={`${process.env.PUBLIC_URL}/img/logo.png`}
                            alt="KD General Transport - Transportation Services Across UAE"
                            style={{ 
                              maxWidth: '200px', 
                              height: 'auto', 
                              display: 'block',
                              width: '100%'
                            }}
                            onError={(e) => {
                              // If logo image fails to load, show text logo
                              e.target.style.display = 'none';
                              const parent = e.target.parentElement;
                              if (parent && !parent.querySelector('.text-logo')) {
                                const textLogo = document.createElement('div');
                                textLogo.className = 'text-logo';
                                textLogo.style.cssText = 'font-size: 24px; font-weight: bold; color: #333; font-family: "Raleway", sans-serif;';
                                textLogo.textContent = 'KD General Transport';
                                parent.appendChild(textLogo);
                              }
                            }}
                          />
                        </Link>
                      </div>
                      {/* .logo end */}
                    </div>
                    {/* .navbar-header start */}
                    {/* MAIN NAVIGATION */}
                    <div 
                      ref={menuRef} 
                      id="navbar-collapse" 
                      className={`collapse navbar-collapse ${isMenuOpen ? 'in' : ''}`}
                      style={isMenuOpen ? { display: 'block' } : {}}
                    >
                      <ul className="nav navbar-nav">
                        <li className={location.pathname === '/' ? 'current-menu-item' : ''}>
                          <Link
                            to="/"
                            data-toggle="dropdown"
                            className="dropdown-toggle"
                            onClick={closeMenu}
                          >
                            Home
                          </Link>

                          {/* .dropdown-menu end */}
                        </li>
                        {/* .dropdown end */}

<li className={`dropdown ${location.pathname.startsWith('/services-overview') || location.pathname.startsWith('/service/') ? 'current-menu-item' : ''}`}>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                            href="#"
                            className="dropdown-toggle"
                            onClick={(e) => {
                              e.preventDefault();
                              // Toggle dropdown on mobile
                              if (window.innerWidth <= 991) {
                                const dropdown = e.currentTarget.parentElement;
                                dropdown.classList.toggle('open');
                              }
                            }}
                          >
                            Services
                          </a>
                          <ul
                            className="dropdown-menu"
                            style={{ visibility: "visible", display: "none" }}
                          >
                            <li>
                              <Link to="/services-overview" onClick={closeMenu}>Services overview</Link>
                            </li>
                            {categories.map(category => {
                              const categorySubs = subcategories.filter(sub => sub.category_id === category.id)
                              if (categorySubs.length === 0) return null
                              
                              return (
                                <li key={category.id} className="dropdown dropdown-submenu">
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                  <a
                                    href="#"
                                    className="dropdown-toggle"
                                    onClick={handleSubmenuToggle}
                                  >
                                    {category.name}
                                  </a>
                                  <ul
                                    className="dropdown-menu"
                                    style={{ visibility: "visible", display: "none" }}
                                  >
                                    {categorySubs.map(sub => (
                                      <li key={sub.id}>
                                        <Link 
                                          to={`/service/${sub.id}`} 
                                          onClick={closeMenu}
                                        >
                                          {sub.name}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              )
                            })}
                          </ul>
                          {/* .dropdown-menu end */}
                        </li>




                        <li className={location.pathname === '/about-us' ? 'current-menu-item' : ''}>
                          <Link to={"/about-us"} onClick={closeMenu}>
                            About Us
                          </Link>

                          {/* .dropdown-menu end */}
                        </li>
                        {/* .dropdown end */}
                        
                        {/* .dropdown end */}

                        {/* .dropdown end */}

                        <li className={`dropdown ${location.pathname === '/contact' ? 'current-menu-item' : ''}`}>
                          <Link
                            to="/contact"
                            data-toggle="dropdown"
                            className="dropdown-toggle"
                            onClick={closeMenu}
                          >
                            Contact
                          </Link>

                          {/* .dropdown-menu end */}
                        </li>
                        {/* .dropdown end */}
                        {state.Admin && (
                          <li className={`${location.pathname.startsWith('/admin') ? 'current-menu-item' : ''}`}>
                            <Link
                              to="/admin"
                              onClick={closeMenu}
                            >
                              Dashboard
                            </Link>
                          </li>
                        )}
                        {/* .dropdown end */}
                      </ul>
                      {/* .nav.navbar-nav end */}
                    </div>
                    {/* MAIN NAVIGATION END */}
                  </nav>
                  {/* .navbar.navbar-default end */}
                </div>
                {/* .col-md-12 end */}
              </div>
              {/* .row end */}
            </div>
            {/* .main-nav end */}
          </div>
          {/* .container end */}
        </header>
        {/* .header.header-style01 */}
      </div>


    </>
  )
}

export default Header
